import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      phoneData: {}
    };

    super('phoneResolver', defaultState, {
      useLocalStorage: false
    });
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.PHONE.RESOLVING, (data) => {
      const phoneNumber = data.phoneNumber;
      this.state.phoneData[phoneNumber] = {
        loading: true,
        data: null,
        error: null
      };
    });

    this.on(constants.EVENTS.PHONE.RESOLVED, (data) => {
      const phoneNumber = data.originalKey || data.id || data.internationalNumber;
      this.state.phoneData[phoneNumber] = {
        data,
        loading: false,
        error: null
      };
    });

    this.on(constants.EVENTS.PHONE.RESOLVE_ERROR, (error) => {
      const phoneNumber = error.originalKey || error.phoneNumber;
      this.state.phoneData[phoneNumber] = {
        loading: false,
        error: error?.message || error,
        data: null
      };
    });
  }
}

export default Store;
